import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'; // Add this import

const AppointmentHistory = () => {
  const { t } = useTranslation(); // Add this hook
  const [consultations, setConsultations] = useState([]);
  const [loading, setLoading] = useState(true);

  const ID = localStorage.getItem('userID')

  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const response = await fetch(`https://xianhefairy.com/LotusFairy_API/api/booking/getAppHistory?ID=${ID}`); 
        const data = await response.json();
        setConsultations(data);
      } catch (error) {
        console.error('Error fetching consultations:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAppointments();
  }, []);

  const handleDownload = async (appointment) => {
    try {
      // Make API call to fetch the MP4 file using BUID
      const response = await fetch(`https://xianhefairy.com/LotusFairy_API/api/video/getRecording?vuid=${appointment.BUID}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch MP4 file');
      }

      // Fetch the file blob
      const blob = await response.blob();

      // Create a link element to trigger the download
      const element = document.createElement('a');
      const url = URL.createObjectURL(blob);
      element.href = url;
      element.download = `${appointment.BUID}_appointment.mp4`; // Name the file using BUID
      element.click();

      // Revoke the object URL after downloading
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const containerStyle = {
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: 'black',
    borderRadius: '10px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    maxWidth: '90vw',
    margin: 'auto',
  };

  const notificationContainerStyle = {
    marginTop: '20px',
  };

  const notificationStyle = {
    backgroundColor: "#DFBD69",
    borderRadius: '10px',
    padding: '15px',
    marginBottom: '15px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.2s',
  };

  const notificationContentStyle = {
    display: 'flex',
    flexDirection: 'column',
  };

  const notificationTitleStyle = {
    fontSize: '18px',
    fontWeight: 'bold',
    margin: 0,
    color: "black",
  };

  const notificationChannelStyle = {
    fontSize: '16px',
    margin: '5px 0',
    color: "black",
  };

  const notificationDateStyle = {
    fontSize: '14px',
    margin: '5px 0',
    color: "black",
  };

  if (loading) {
    return <p style={{ color: '#DFBD69', textAlign: 'center', padding: '20px' }}>{t('appointment.loading')}</p>;
  }

  return (
    <div style={{ ...containerStyle, height: '90vh', display: 'flex', flexDirection: 'column' }}>
      <h1 style={{color: "#DFBD69"}}>{t('appointment.title')}</h1>
      <div style={{ 
        flex: 1, 
        overflowY: 'auto', 
        maxHeight: '80vh', 
        padding: '10px', 
        border: '1px solid #DFBD69', 
        borderRadius: '5px' 
      }}>
        {consultations.length > 0 ? (
          consultations.map((consultation) => (
            <div
              key={consultation.UID}
              style={notificationStyle}
              onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
              onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            >
              <div style={notificationContentStyle}>
                {/* Circular and larger image */}
                {/* <img 
                  src={consultation.imageUrl} 
                  alt={t('appointment.imageAlt')}
                  style={{
                    width: '80px', // Increase size
                    height: '80px', // Keep it square
                    borderRadius: '50%', // Makes it circular
                    objectFit: 'cover', // Ensures the image fills the space
                    marginBottom: '10px'
                  }} 
                /> */}
                <h3 style={notificationTitleStyle}>
                  {t('appointment.appointmentWith', { channel: consultation.CHANNEL })}
                </h3>
                <p style={notificationChannelStyle}>
                  {t('appointment.channel')}: {consultation.CHANNEL}
                </p>
                <p style={notificationDateStyle}>
                  {t('appointment.bookingDate')}: {new Date(consultation.BOOKING_DATE).toLocaleString()}
                </p>
              </div>
              {/* <button
                onClick={() => handleDownload(consultation)}
                disabled={true}
                aria-disabled={true}
                style={{
                  marginTop: '10px',
                  padding: '10px 20px',
                  backgroundColor: '#d3d3d3',
                  color: '#777',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'not-allowed',
                  fontSize: '14px',
                }}
              >
                {t('appointment.downloadMP4')}
              </button> */}
            </div>
          ))
        ) : (
          <p style={{ color: '#DFBD69', textAlign: 'center', padding: '20px' }}>
            {t('appointment.noAppointments')}
          </p>
        )}
      </div>
    </div>
  );
}  

export default AppointmentHistory;